import { trpcCall } from "./trpc";

const POLL_INTERVAL_MS = 3000;
const TIMEOUT_MS = 10 * 60 * 1000; // 10 min

interface PreviewStatus {
  status: "processing" | "ready" | "failed";
  progress: number;
  errorReason?: string;
}

export async function pollPreviewStatus(
  projectId: string,
  onUpdate: (status: PreviewStatus) => void
): Promise<PreviewStatus> {
  const start = Date.now();
  while (true) {
    const result = await trpcCall<PreviewStatus>(
      "project.anonymousGetPreviewStatus",
      { projectId },
      { method: "query" }
    );
    onUpdate(result);

    if (result.status === "ready" || result.status === "failed") {
      return result;
    }

    if (Date.now() - start > TIMEOUT_MS) {
      return {
        status: "failed",
        progress: 0,
        errorReason: "Timed out waiting for processing",
      };
    }

    await new Promise((r) => setTimeout(r, POLL_INTERVAL_MS));
  }
}
